import Loader, { LoaderOptions } from '@/components/modal/Loader.vue'

// 摧毀實體前等待時間 (等待 Modal 關閉的動畫)
const DestroyTimeout = 1500

/**
 * 使用 Loader 處理非同步等待
 * @param loader 要等待的非同步處理
 */
export function useLoader<T>(loader: Promise<T>, options: LoaderOptions = {}): Promise<T> {
  const { vNode: modal, destroy } = useMount(Loader, {
    app: useNuxtApp().vueApp, props: {
      loader,
      ...options,
    }
  })

  // 結束時自動摧毀
  whenever(() => modal.component?.exposed?.finished?.value === true, () => {
    setTimeout(() => destroy(), DestroyTimeout)
  })

  // 顯示
  return modal.component?.exposed?.start()

}